var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 0.5C6.69171 0.5 3.33337 3.85833 3.33337 8H0.833374L4.07504 11.2417L4.13337 11.3583L7.50004 8H5.00004C5.00004 4.775 7.60837 2.16667 10.8334 2.16667C14.0584 2.16667 16.6667 4.775 16.6667 8C16.6667 11.225 14.0584 13.8333 10.8334 13.8333C9.22504 13.8333 7.76671 13.175 6.71671 12.1167L5.53337 13.3C6.89171 14.6583 8.75837 15.5 10.8334 15.5C14.975 15.5 18.3334 12.1417 18.3334 8C18.3334 3.85833 14.975 0.5 10.8334 0.5ZM10 4.66667V8.83333L13.5667 10.95L14.1667 9.94167L11.25 8.20833V4.66667H10Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 0.5C6.69171 0.5 3.33337 3.85833 3.33337 8H0.833374L4.07504 11.2417L4.13337 11.3583L7.50004 8H5.00004C5.00004 4.775 7.60837 2.16667 10.8334 2.16667C14.0584 2.16667 16.6667 4.775 16.6667 8C16.6667 11.225 14.0584 13.8333 10.8334 13.8333C9.22504 13.8333 7.76671 13.175 6.71671 12.1167L5.53337 13.3C6.89171 14.6583 8.75837 15.5 10.8334 15.5C14.975 15.5 18.3334 12.1417 18.3334 8C18.3334 3.85833 14.975 0.5 10.8334 0.5ZM10 4.66667V8.83333L13.5667 10.95L14.1667 9.94167L11.25 8.20833V4.66667H10Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.d5308e958248f9b93ba4ed5facbcf81b.svg";
export { ForwardRef as ReactComponent };